module.exports = __webpack_public_path__ + "img/source-icon.89759c00.svg";